export const environment = {
    production: false,
    apiUrl: 'https://proapp.easyliensflorida.com'// Placeholder
};
